import React from 'react';
import { useForm } from 'react-hook-form';

import { CancelButton, FormButton } from '../../../../../components/Button';
import CustomDropdown from '../../../../../components/DropDown';
import { FormFieldset, Input } from '../../../../../components/Form';
import Loader from '../../../../../components/Loader';
import { IAddClient } from '../../Client.props';
import useAddClient from './useAddClient';

const AddClient: React.FC = () => {
  const {
    loading,
    formData,
    handleChange,
    handleSubmit,
    handleCancel,
    setInterestId,
    interest,
    interestId,
    services,
    serviceId,
    setServiceId,
    outputStatuses,
    outputStatusId,
    setOutputStatusId,
    platforms,
    platformId,
    setPlatformId,
  } = useAddClient();
  const { handleSubmit: useFormSubmit } = useForm<IAddClient>();

  const personalFields = [
    { label: "Client Name", name: "name", type: "text" },
    { label: "Company Name", name: "companyName", type: "text" },
    { label: "Email", name: "email", type: "email" },
    { label: "Phone", name: "phone", type: "tel" },
    { label: "Description", name: "description", type: "text" },
    { label: "LinkedIn", name: "linkedin", type: "text" },
  ] as const;

  return (
    <div className="flex flex-col items-center w-full h-full pr-8 pl-6 ">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full ">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-fontBlack ml-5">Add Client</h1>
        </div>
        {loading && <Loader />}
        <form
          onSubmit={useFormSubmit(handleSubmit)}
          className="space-y-6 p-6 h-[75vh] overflow-y-scroll"
        >
          <FormFieldset Ftitle="Personal details">
            <div className="grid grid-cols-4  m-4 gap-4">
              <CustomDropdown
                label="Interest"
                options={interest}
                defaultOptionId={interestId}
                setDefaultOptionId={setInterestId}
                displayProperty="name"
                value={interestId}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full mb-4"
              />
              <CustomDropdown
                label="Services"
                options={services}
                defaultOptionId={serviceId}
                setDefaultOptionId={setServiceId}
                displayProperty="name"
                value={serviceId}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full mb-4"
              />
              <CustomDropdown
                label="Output Status"
                options={outputStatuses}
                defaultOptionId={outputStatusId}
                setDefaultOptionId={setOutputStatusId}
                displayProperty="name"
                value={outputStatusId}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full mb-4"
              />
              <CustomDropdown
                label="Platforms"
                options={platforms}
                defaultOptionId={platformId}
                setDefaultOptionId={setPlatformId}
                displayProperty="name"
                value={platformId}
                style="flex items-center border h-12 rounded-lg shadow-none relative text-sm border-border text-fontColor w-full mb-4"
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 m-4">
              {personalFields.map((field) => (
                <Input
                  key={field.name}
                  name={field.name}
                  label={field.label}
                  type={field.type}
                  value={formData[field.name]}
                  onChange={handleChange}
                />
              ))}
            </div>
          </FormFieldset>

          <div className="flex justify-center mt-6 ml-2 gap-3">
            <CancelButton
              className="py-2 px-4 h-[56px] w-[200.5px]"
              onClick={handleCancel}
              children="Cancel"
              type="button"
            />
            <FormButton
              className="py-2 px-4  h-[56px] w-[200.5px]"
              type="submit"
              children="ADD"
            />
          </div>
        </form>
      </div>
    </div>
  );
};
export default AddClient;
